// Mock data for art portfolio - Saloni Sharma's Artwork
export const mockGalleryData = [
  {
    id: 1,
    title: "Smriti Mool (Roots of Memory)",
    description: "A reflection on heritage and cultural memory",
    medium: "Metallic Acrylic on Canvas",
    dimensions: '16" X 18"',
    year: "2024",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Smiriti_Mool_16x18.jpg",
    available: true
  },
  {
    id: 2,
    title: "Garden of Life",
    description: "Warli art inspired piece celebrating life and community",
    medium: "Acrylic on Canvas",
    dimensions: '16" X 18"',
    year: "2024",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Garden_of_life_16X20_x3OplKS.jpg",
    available: false
  },
  {
    id: 3,
    title: "Pravah (Flow)",
    description: "Capturing the essence of movement and continuity",
    medium: "Acrylic on Canvas",
    dimensions: '18" X 16"',
    year: "2024",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Pravah_Flow_16x18_7avAjo3.jpg",
    available: true
  },
  {
    id: 4,
    title: "Musical Melody",
    description: "Set of 3 celebrating the rhythm of music",
    medium: "Metallic Acrylic on Canvas",
    dimensions: '9" X 9"',
    year: "2024",
    category: "Abstract",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/9._Musical_Medley.jpg",
    available: true
  },
  {
    id: 5,
    title: "Tree of Life",
    description: "Gond art inspired celebration of nature",
    medium: "Acrylic on Canvas",
    dimensions: '12" X 16"',
    year: "2024",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Tribal_art_11_X_14.jpg",
    available: true
  },
  {
    id: 6,
    title: "Peacock",
    description: "Gond art inspired majestic bird",
    medium: "Acrylic on Canvas",
    dimensions: '12" X 16"',
    year: "2023",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/gond_art_.JPG",
    available: false
  },
  {
    id: 7,
    title: "Resilient Fish",
    description: "Gond art inspired symbol of perseverance",
    medium: "Acrylic on Canvas",
    dimensions: '16" X 18"',
    year: "2024",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/resilient_fish_16X18_2sjF9I1.jpg",
    available: true
  },
  {
    id: 8,
    title: "Timeless Pair",
    description: "Gond art inspired celebration of connection",
    medium: "Acrylic on Canvas",
    dimensions: '24" X 18"',
    year: "2024",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Timeless_pair_18x24_wIIQSA0.jpg",
    available: true
  },
  {
    id: 9,
    title: "Birch Trees",
    description: "Vibrant landscape celebrating nature's beauty",
    medium: "Acrylic on Canvas",
    dimensions: '16" X 20"',
    year: "2024",
    category: "Landscape",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/birch_colourfull_16x20.jpg",
    available: true
  },
  {
    id: 10,
    title: "Bloom",
    description: "Tulip landscape celebrating spring",
    medium: "Acrylic on Canvas",
    dimensions: '5.8" X 8.3"',
    year: "2024",
    category: "Landscape",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Landscape_tulip.JPG",
    available: true
  },
  {
    id: 11,
    title: "4 Seasons 1 Frame",
    description: "Celebrating the cycle of nature",
    medium: "Acrylic on Canvas",
    dimensions: '12" X 14"',
    year: "2024",
    category: "Landscape",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Seasons_painting_mfbHlQg.jpg",
    available: true
  },
  {
    id: 12,
    title: "Elephant",
    description: "Madhubani inspired celebration of strength",
    medium: "Acrylic on Canvas",
    dimensions: '20" X 10"',
    year: "2024",
    category: "Folk Art",
    imageUrl: "https://api.artwithsaloni.com/media/gallery/Elephant_20x10.jpg",
    available: true
  }
];

export const mockAboutData = {
  name: "Saloni Sharma",
  title: "Visual Artist & Community Art Instructor",
  bio: "Saloni Sharma is a Calgary (Moh-kins-tsis)–based visual artist, interior designer, and community art instructor, originally from India. She has been passionate about art since her childhood, though family responsibilities and cultural expectations prevented her from pursuing art as a profession. During the pandemic, she found time for making art and began sharing her skills through volunteer workshops for children, seniors, and immigrant communities.",
  statement: "My art explores culture, memory, and the natural world. I work with mixed media, recycled materials, and Indian folk techniques to create pieces that tell stories, evoke emotion, and invite reflection. Art is both personal and communal for me. I lead workshops for children, seniors, and immigrant communities, and love creating something different to share. Through my practice, I aim to celebrate heritage, foster belonging, and create inclusive spaces where people of all ages and backgrounds can connect, express themselves, and find joy in making.",
  mission: "I believe in the process of art to heal, inspire, and bring people together. My mission is to use creativity as a tool for social change and personal growth.",
  specializations: [
    "Acrylic Painting",
    "Indian Folk Art (Warli, Gond, Madhubani)",
    "Mixed Media & Recycled Materials",
    "Community Art Workshops",
    "Flower Making & Weaving",
    "Upcycling Art Projects"
  ],
  exhibitions: [
    "Arts Commons Exhibition, Calgary",
    "Canmore Exhibition",
    "Teeny Tiny Gallery",
    "Mini Galleries Showcase",
    "Pumphouse Theatre"
  ],
  imageUrl: "https://artwithsaloni.com/public/Canmore.JPG",
  workshopImage: "https://artwithsaloni.com/public/IMG-20240202-WA0006.jpg"
};
